import { trpcAdmin } from './lib/trpcAdmin';
import type { NotificationChannelMessage } from '@duke-hq/svc-api/admin/web-api';

interface WithNotificationsProps {
  children: React.ReactNode;
}

type Utils = ReturnType<typeof trpcAdmin.useUtils>;

// -- Type-safe invalidation config — keyed by notification type ----------
const invalidationHandlers: Partial<
  Record<NotificationChannelMessage['type'], (utils: Utils) => void>
> = {
  unreadTicketCount: (utils) => {
    void utils.support.ticket.list.invalidate();
  },
};

/**
 * Type-safe automatic cache updater for SSE notifications.
 *
 * Convention: notification.type must match the tRPC query procedure name.
 */
export function WithNotifications({ children }: WithNotificationsProps) {
  const utils = trpcAdmin.useUtils();

  trpcAdmin.notifications.subscribe.useSubscription(undefined, {
    onData: (notification) => {
      // Update the react-query cache with the notification payload
      switch (notification.type) {
        case 'flags':
          utils.notifications.flags.setData(undefined, notification.payload);
          break;
        case 'unreadTicketCount':
          utils.notifications.unreadTicketCount.setData(undefined, notification.payload);
          break;
        default:
          notification satisfies never;
      }

      // Run type-safe invalidations
      invalidationHandlers[notification.type]?.(utils);
    },
  });

  return children;
}
